<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-08-31 11:12:21
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-11-08 10:59:59
 * @FilePath: \official_website\src\views\products\details\Dna.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 细胞学TCT人工智能辅助诊断  -->
<template>
  <div id="tctProd">
    <Header></Header>
    <div class="tctProd-conter">
      <div class="tctProd-img">
        <Breadcrumb
          :productType="productType"
          :productName="productName"
        ></Breadcrumb>
        <!-- <img src="@/assets/image/product-detail/programme-3.png" alt="" /> -->

        <!-- <div class="illustrate-box">
          <div class="title wow animate__animated animate__fadeInUp">
            细胞学TCT人工智能辅助诊断
          </div>
          <div class="line"></div>
          <ul class="keywords wow animate__animated animate__fadeInUp">
            <li>超快</li>
            <li>灵活</li>
            <li>便捷</li>
            <li>安全</li>
          </ul>
        </div> -->

        <!-- <div class="tctProd-introduction">
          <van-swipe
            :autoplay="3000"
            indicator-color="#0b847b"
            width="100%"
            height="100%"
            class="swiper-box"
          >
            <van-swipe-item class="swiper-item">
              <h3 class="title">细胞学辅助诊断</h3>
            </van-swipe-item>
          </van-swipe>
        </div> -->

        <div class="cytology-container">
          <h1 class="main-title">
            细胞学TCT人工智能辅助诊断
            <!-- <span class="subtitle-text">(科研方向)</span> -->
          </h1>

          <!-- :autoplay="3000" -->
          <!-- indicator-color="#0b847b" -->

          <el-carousel
            indicator-position="outside"
            width="100%"
            height="43.75rem"
            class="swiper-box"
            arrow="never"
            :autoplay="true"
            trigger="click"
            @change="changeSlide"
            :interval="5000"
          >
            <el-carousel-item v-for="item in cellInfo" :key="item.id">
              <div class="content-wrapper">
                <!-- 左侧内容区 -->
                <div class="left-section">
                  <h2 class="project-title wow animate__animated animate__fadeInUp" data-wow-delay="0.8s">{{ item.title }}</h2>

                  <!-- 识别细胞类型展示 -->
                  <div class="cell-types-section">
                    <div class="section-item">
                      <!-- <div class="item-title">
                      <span
                        class="feature-bullet"
                        style="margin-right: 10px"
                      ></span>
                      <span>{{ item.headerTitle }}</span>
                    </div> -->
                      <div class="cell-list wow animate__animated animate__fadeInRight">
                        <div
                          class="cell-item"
                          v-for="ij in item.cellTypes"
                          :key="ij.name"
                        >
                          <div class="cell-image-box">
                            <img :src="ij.img" alt="" class="cell-img" />
                          </div>
                          <span class="cell-label">{{ ij.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右侧图片区 -->
                <div class="right-section">
                  <div class="monitor-container">
                    <div class="prod-img">
                      <img
                        :src="item.prod_img"
                        alt="系统界面"
                        class="monitor-screen"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 功能列表 -->
              <div class="feature-list">
                <div
                  class="feature-item wow animate__animated animate__fadeInRight"
                  v-for="(feature, index) in item.features"
                  :key="index"
                  :data-wow-delay="`${index * 0.5}s`"
                >
                  <span class="feature-bullet"></span> 
                  <span class="feature-text">{{ feature }}</span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- <div class="tctProd-description">
        <div class="parameter">
          <img
            class="wow animate__animated animate__fadeInUp"
            src="@/assets/image/tctProd/parameter.png"
            alt=""
          />
        </div>
        <div class="characteristic">
          <ul class="feature-box">
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/tctProd/icon-1.png"
                  alt="免漏检"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">免漏检</div>
                <div class="desc">全片扫描、全片分析，减少漏检情况发生</div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/tctProd/icon-1.png"
                  alt="效率高"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">效率高</div>
                <div class="desc">
                  15*15mm切片样本扫描+分析时间≤2分钟，相比传统人工镜下阅片，效率提升3倍，本地AI，无需上传至服务器，节省上传时间。
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/tctProd/icon-1.png"
                  alt="初筛准"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">初筛准</div>
                <div class="desc">
                  超1000万级数据训练模型，阳性符合率≥99.7%，排阴率≥71%
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/tctProd/icon-1.png"
                  alt="报告全"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">报告全</div>
                <div class="desc">
                  TBS 15分类诊断标准自动判读和分类，帮助医生快速识别。
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/tctProd/icon-1.png"
                  alt="模型全"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">模型全</div>
                <div class="desc">
                  具备泛化和非泛化两种模型，可兼容妇科、非妇科样本。
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div> -->

      <RelatedProduct :swiperData="relatProd"></RelatedProduct>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import Header from "@/views/componets/Header.vue";
import Footer from "@/views/componets/Footer.vue";
import RelatedProduct from "../componets/RelatedProduct.vue";
import Breadcrumb from "@/views/componets/Breadcrumb.vue";
import api from "../../../api/api";

export default {
  name: "",
  props: {},
  components: {
    Header,
    Footer,
    RelatedProduct,
    Breadcrumb,
  },
  data() {
    return {
      productType: "产品",
      productName: "细胞学TCT人工智能辅助诊断",
      relatProd: [
        {
          title: "液基制片染色一体机",
          src: require("@/assets/image/product/film-1.png"),
          path: "/product/pelleter",
        },
        {
          title: "液基膜式制片机",
          src: require("@/assets/image/product/film-2.png"),
          path: "/product/film",
        },
        {
          title: "液基细胞学TCT诊断试剂",
          src: require("@/assets/image/product/reagent-1.png"),
          path: "/product/tctReagent",
        },
        {
          title: "扫描通量600片",
          src: require("@/assets/image/product/digit-1.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量120片",
          src: require("@/assets/image/product/digit-2.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量30片",
          src: require("@/assets/image/product/digit-3.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量2片",
          src: require("@/assets/image/product/digit-4.png"),
          path: "/product/gemini",
        },
      ],
      urlPath: "", // 当前路由
      allProdList: [], // 所有产品数据
      currentList: {}, // 当前页面数据
      cellInfo: [
        {
          id: 1,
          title: "宫颈细胞学智能早筛",
          // headerTitle: "自动识别10类细胞",
          cellTypes: [
            { name: "AGC", img: require("../../../assets/image/tctProd/cervix/AGC.png") },
            { name: "ASCH", img: require("../../../assets/image/tctProd/cervix/ASCH.png") },
            { name: "ASCUS", img: require("../../../assets/image/tctProd/cervix/ASCUS.png") },
            { name: "BV", img: require("../../../assets/image/tctProd/cervix/BV.png") },
            { name: "E", img: require("../../../assets/image/tctProd/cervix/E.png") },
            { name: "HSIL", img: require("../../../assets/image/tctProd/cervix/HSIL.png") },
            { name: "HSV", img: require("../../../assets/image/tctProd/cervix/HSV.png") },
            { name: "LSIL", img: require("../../../assets/image/tctProd/cervix/LSIL.png") },
            { name: "M", img: require("../../../assets/image/tctProd/cervix/M.png") },
            { name: "SCC", img: require("../../../assets/image/tctProd/cervix/SCC.png") },
            { name: "T", img: require("../../../assets/image/tctProd/cervix/T.png") },
            { name: "放线菌", img: require("../../../assets/image/tctProd/cervix/放线菌.png") },
            { name: "化生", img: require("../../../assets/image/tctProd/cervix/化生.png") },
            { name: "颈管腺", img: require("../../../assets/image/tctProd/cervix/颈管腺.png") },
            { name: "子宫内膜癌", img: require("../../../assets/image/tctProd/cervix/子宫内膜癌.png") },
          ],
          features: [
            "减少漏诊: 全片扫描，全片智能分析，敏感性≥99.7%",
            "提高效率: 千万级数据训练，排阴率≥71%，减轻医生阅片负荷",
            "规范诊断: 标准19分类，降低主观误差，保证结果的一致性",
            "适用广泛: 适用于区域诊疗中心、大型三方医学实验室、两癌筛查",
          ],
          prod_img: require("../../../assets/image/tctProd/cervix/prod_yeji.png"),
        },
        {
          id: 2,
          title: "尿液细胞学智能早筛",
          cellTypes: [
            { name: "NILM", img: require("../../../assets/image/tctProd/urine/NILM.jpg") },
            { name: "AUC", img: require("../../../assets/image/tctProd/urine/AUC.jpg") },
            { name: "HGUC", img: require("../../../assets/image/tctProd/urine/HGUC.jpg") },
            { name: "SHGUC", img: require("../../../assets/image/tctProd/urine/SHGUC.jpg") },
          ],
          features: [
            "癌症早筛: 尿液细胞学加入体检套餐，筛查高风险人群（45岁以上）",
            "辅助诊断: 可作为尿液FISH，甲基化检测的初始评估",
            "术后监测: 膀胱癌术后5年复发率70%，共识推荐可作为复发追踪的有效手段",
            "血尿查因: 鉴别感染/结石/肿瘤性病变",
          ],
          prod_img: require("../../../assets/image/tctProd/urine/prod_ny.png"),
        },
        {
          id: 3,
          title: "甲状腺细胞学智能早筛",
          cellTypes: [
            { name: "AUC", img: require("../../../assets/image/tctProd/thyroid/AUC.jpg") },
            { name: "MTC", img: require("../../../assets/image/tctProd/thyroid/MTC.jpg") },
            { name: "NILM", img: require("../../../assets/image/tctProd/thyroid/NILM.jpg") },
            { name: "PTC", img: require("../../../assets/image/tctProd/thyroid/PTC.jpg") },
            { name: "SPTC", img: require("../../../assets/image/tctProd/thyroid/SPTC.jpg") },
            { name: "巨噬细胞", img: require("../../../assets/image/tctProd/thyroid/巨噬细胞.jpg") },
            // { name: "巨噬细胞-2", img: require("../../../assets/image/tctProd/thyroid/巨噬细胞-2.jpg") },

          ],
          features: [
            "鉴别甲状腺结节的良恶性，减少不必要的手术治疗。甲状腺FNA是甲状腺结节评估的最有效手段，契合临床迫切开展需求",
            "术前明确肿瘤的恶性性质，减少术中冰冻。甲状腺FNA诊断恶性肿瘤，尤其是PTC的特异性很高，可减少术中冰冻的开展，缩短手术时间",
          ],
          prod_img: require("../../../assets/image/tctProd/thyroid/prod_jzx.png"),
        },
        {
          id: 4,
          title: "子宫内膜细胞学智能早筛",
          cellTypes: [
            { name: "TYS-1", img: require("../../../assets/image/tctProd/endometrium/TYS-1.jpg") },
            // { name: "TYS-2", img: require("../../../assets/image/tctProd/endometrium/TYS-2.jpg") },
            { name: "TYS-2", img: require("../../../assets/image/tctProd/endometrium/TYS-2-2.jpg") },
            { name: "TYS-3", img: require("../../../assets/image/tctProd/endometrium/TYS-3.jpg") },
            { name: "TYS-4", img: require("../../../assets/image/tctProd/endometrium/TYS-4.png") },
            { name: "TYS-5", img: require("../../../assets/image/tctProd/endometrium/TYS-5.jpg") },
            { name: "TYS-6", img: require("../../../assets/image/tctProd/endometrium/TYS-6.jpg") },
          ],
          features: [
            "早期筛查: 门诊5-10分钟取样，及时发现非典型增生，上皮内瘤变及病变细胞，为早期干预提供依据",
            "耐受性好: 尤其适用于绝经后女性、宫颈狭窄或恐惧手术的患者",
            "辅助诊断: 对于异常子宫出血、月经不调等症状，可排除子宫内膜器质性病变，为功能性子宫出血等疾病的诊断提供参考",
            "长期随访: 可用于子宫内膜增生、子宫内膜癌术后患者的长期随访，及时发现异常改变",
          ],
          prod_img: require("../../../assets/image/tctProd/endometrium/prod_nm.png"),
        },
      ],
    };
  },
  async created() {
    await this.getPordList(1, 100, {});
    await this.getChooseId(this.currentList.id);
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: "wow", // 动画元件css类（默认为wow）
        animateClass: "animate__animated", //动画css类（默认为animated）
        offset: 0, //到元素距离触发动画（当默认为0）
        mobile: true, //在移动设备上触发动画（默认为true）
        live: true, //对异步加载的内容进行操作（默认为true）
      }).init();
    });
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from) {
        // console.log(to.path);
        this.urlPath = to.path;
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    // 获取所有产品信息
    async getPordList(pageIndex, pageSize, params) {
      try {
        var res = await api.getPorductList(pageIndex, pageSize, params);
        if (res && res.data && res.data.code === 200) {
          this.allProdList = res.data.models;
          let presentProd = this.allProdList.filter((item) => {
            return item.summary == this.urlPath;
          });
          this.currentList = presentProd.length != 0 ? presentProd[0] : 0;
        } else {
        }
      } catch (error) {}
    },
    // 获取相关产品信息
    async getChooseId(prodId) {
      try {
        var res = await api.getProdRelationByid(prodId);
        if (res && res.data && res.data.code === 200) {
          if (res.data.models) {
            let result = res.data.models[0].relationID;
            if (result) {
              let relationArr = result.split(",");
              let tepmArr = [];
              relationArr.forEach((item) => {
                tepmArr.push(Number(item));
              });

              let relatedList = [];
              tepmArr.forEach((items) => {
                let secData = this.allProdList.filter((item) => {
                  return item.id == items;
                });
                if (secData.length != 0) {
                  relatedList.push(secData[0]);
                }
              });

              this.relatProd = relatedList;
            } else {
            }
          }
        } else {
        }
      } catch (error) {}
    },
    changeSlide() {
      // 每次切换幻灯片时，重新初始化 WOW.js 以触发动画
      this.$nextTick(() => {
        new this.$wow.WOW({
          boxClass: "wow", // 动画元件css类（默认为wow）
          animateClass: "animate__animated", //动画css类（默认为animated）
          offset: 0, //到元素距离触发动画（当默认为0）
          mobile: true, //在移动设备上触发动画（默认为true）
          live: true, //对异步加载的内容进行操作（默认为true）
        }).init();
      });
    },
  },
};
</script>
    
<style lang="scss">
#tctProd {
  width: 100%;
  height: 100%;
  .tctProd-conter {
    padding-top: 5rem;
    .tctProd-img {
      position: relative;
      // height: 50rem;
      // background-image: url("../../../assets/image/product-detail/programme-1.png");
      // background-size: cover;
      // img {
      //   width: 100%;
      // }
      .illustrate-box {
        position: absolute;
        left: 18%;
        top: 30%;
        width: 21.875rem;
        .title {
          font-size: 1.8rem;
          font-family: "SourceHanSansSC-Medium";
          margin-bottom: 2.8125rem;
        }
        .line {
          width: 4.25rem;
          height: 3px;
          margin-bottom: 1.25rem;
          background: #177a73;
        }
        .keywords {
          display: flex;
          li {
            width: 22%;
            height: 2.1875rem;
            line-height: 2.1875rem;
            margin-right: 4%;
            color: #fff;
            background: #177a73;
            border-radius: 2.1875rem;
            text-align: center;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }
      }

      .tctProd-introduction {
        width: 80%;
        height: 100%;
        margin: 0 auto;
        padding: 2rem 0;
        .swiper-box {
          .swiper-item {
            .title {
              width: 240px;
              font-size: 30px;
              font-weight: 400;
              padding-bottom: 15px;
              &::after {
                position: absolute;
                content: "";
                width: 240px;
                height: 4px;
                left: 0;
                bottom: -2px;
                background: #000;
              }
            }
          }
        }
      }

      .cytology-container {
        width: 100%;
        // min-height: 100vh;
        background-color: #f5f7fa;
        // background-image: radial-gradient(
        //   circle,
        //   rgba(200, 220, 255, 0.3) 0%,
        //   transparent 70%
        // );
        background-image: url("../../../assets/image/tctProd/tct_bg.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: cover;
        padding: 40px 60px;
        box-sizing: border-box;

        .content-wrapper {
          display: flex;
          align-items: center;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
        }

        .left-section {
          flex: 1;
        }

        .main-title {
          font-size: 36px;
          font-weight: 700;
          color: #1a1a1a;
          max-width: 87.5rem;
          margin: 0 auto;
          margin-bottom: 30px;
          // padding-left: 12rem;
        }

        .subtitle-text {
          font-size: 28px;
          font-weight: 500;
          color: #444;
          margin-left: 8px;
        }

        .project-title {
          font-size: 28px;
          color: #333;
          font-weight: 500;
          padding-bottom: 10px;
          border-bottom: 2px solid #333;
          display: inline-block;
          margin: 0 0 30px 0;
        }

        .section-item {
          margin-bottom: 30px;
        }

        .item-title {
          font-size: 20px;
          color: #222;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
        }

        .cell-list {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }

        .cell-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
        }

        .cell-image-box {
          width: 64px;
          height: 64px;
          background-color: #fff;
          border-radius: 4px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .cell-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .cell-label {
          font-size: 14px;
          color: #333;
          font-weight: 500;
        }

        .feature-list {
          padding-top: 3rem;
          display: flex;
          flex-direction: column;
          gap: 20px;
          width: 100%;
          max-width: 87.5rem;
          margin: 0 auto;
        }

        .feature-item {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .feature-bullet {
          width: 4px;
          height: 20px;
          background-color: #222;
          flex-shrink: 0;
        }

        .feature-text {
          font-size: 18px;
          color: #333;
          line-height: 1.8;
        }

        .right-section {
          flex: 1;
          display: flex;
          justify-content: center;
        }

        .monitor-container {
          position: relative;
          width: 100%;
          height: 420px;
          // max-width: 650px;
          // aspect-ratio: 16 / 9;
          // background-color: #111;
          background-image: url("../../../assets/image/tctProd/competer.png");
          background-repeat: no-repeat;
          background-position: 0 0;
          background-size: cover;
          border-radius: 12px;
          padding: 10px;
          // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          .prod-img {
            position: absolute;
            left: 47px;
            top: 15px;
            width: 574px;
            height: 325px;
            border-radius: 8px;
            background-color: #fff;
            aspect-ratio: 16 / 9;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }

        .monitor-screen {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }

        .el-carousel__button {
          width: 3rem;
          height: 0.35rem;
          background-color: #333!important;
        }
      }
    }
    .tctProd-description {
      width: 100%;
      padding: 3.75rem 15%;
      .parameter {
        width: 100%;
        margin: 2rem 0 5rem;
        img {
          display: block;
          width: 90%;
          margin: auto;
        }
      }
      .characteristic {
        width: 90%;
        margin: auto;
        .feature-box {
          display: flex;
          flex-wrap: wrap;
          .feature-item {
            display: flex;
            align-items: center;
            width: 48%;
            margin-bottom: 2rem;
            margin-right: 4%;
            &:nth-of-type(2n) {
              margin-right: 0;
            }
            .left {
              width: 10%;
              margin-right: 1.2rem;
              img {
                width: 100%;
              }
            }
            .right {
              width: 90%;
              .title {
                font-size: 1.4rem;
                font-family: "SourceHanSansSC-Medium";
                margin-bottom: 1rem;
              }
              .desc {
                font-size: 1rem;
                font-family: "OPlusSans3-Regular";
              }
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 6.25rem 8% 3.125rem;
  }
}
</style>